// © Microsoft Corporation. All rights reserved.

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { PopOverClassNameContract } from "./PopOver.classnames";
import { ZIndex } from "@msnews/core";

/**
 * The main JSS stylesheet for the popover component
 */
export const PopOverStyles: ComponentStyles<PopOverClassNameContract, DesignSystem> = {
    popOver: {
        "animation-duration": "0.367s",
        "animation-fill-mode": "both",
        "animation-name": "fadeIn, slideIn",
        "animation-timing-function": "cubic-bezier(0.1, 0.9, 0.2, 1)",
        position: "absolute",
        "z-index": `${ZIndex.Flyout}`,
        "&:focus": {
            outline: "none"
        }
    },
    popOverPlaceholder: {
        left: "50%",
        top: "50%",
        position: "absolute",
        visibility: "hidden"
    },
    "@keyframes fadeIn": {
        from: { opacity: 0 },
        to: { opacity: 1 }
    },
    "@keyframes slideIn": {
        from: { transform: "translate3d(0px, -10px, 0px)" },
        to: { transform: "translate3d(0px, 0px, 0px)" }
    }
};